// extracted by mini-css-extract-plugin
module.exports = {"btnAction":"autocomplete-action_btnAction__FIY9P","fade-in":"autocomplete-action_fade-in__BzBwG"};